import React from 'react'

const SvgShare = ({ title, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
    <title>{title}</title>
    <g fill="none">
      <path d="M6 6h12v6H6z" />
      <path stroke="#1557BF" strokeLinecap="round" d="M6 12l12-6" />
      <path d="M6 18h12v-6H6z" />
      <path stroke="#1557BF" strokeLinecap="round" d="M6 12l12 6" />
      <circle cx="7" cy="12" r="2.5" fill="#FFF" stroke="#1557BF" />
      <circle cx="17" cy="7" r="2.5" fill="#FFF" stroke="#1557BF" />
      <circle cx="17" cy="17" r="2.5" fill="#FFF" stroke="#1557BF" />
    </g>
  </svg>
)

export default SvgShare
